<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('reactor.macro_reflect')}}</span>
  </template>

  <scene-selector multiple v-model="selectedScenes" :label="$t('reactor.select_scene_to_trigger')" clearable></scene-selector>
  <contact-selector v-model="selectedContacts" :label="$t('reactor.emails_to_notify')"></contact-selector>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn color="primary" flat @click="save">{{ $t('reactor.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import ContactSelector from '@/components/contact/ContactSelector'
import SceneSelector from '@/components/scene/SceneSelector'

export default {
  name: 'MacroSceneDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    'standard-dialog': Dialog,
    'contact-selector': ContactSelector,
    'scene-selector': SceneSelector
  },
  data() {
    return {
      selectedScenes: [],
      selectedContacts: [],
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    scenesToSave() {
      return this.selectedScenes.reduce((acc, cur) => {
        let [mac, scene] = cur.split('-');
        acc[cur] = {
          mac: mac,
          scene: Buffer.from(scene, 'base64').toString()
        };
        return acc;
      }, {});
    },
    contactToSave() {
      return this.selectedContacts.reduce((acc, cur) => {
        acc[cur] = this.userContact[cur];
        return acc;
      }, {});
    },
    dataToSave() {
      let data = {};
      if (Object.keys(this.scenesToSave).length > 0)
        data.scene = this.scenesToSave;
      if (Object.keys(this.contactToSave).length > 0)
        data.notify = this.contactToSave;
      if (Object.keys(data.scene || {}).length > 0 || Object.keys(data.notify || {}).length > 0)
        return data;
      else
        return null
    }
  },
  methods: {
    save() {
      let data = this.dataToSave;
      let ref = this.$db.ref('userMacroScene').child(this.userId).child(this.item.key);
      if (data) {
        ref.set(data)
          .then(() => this.visible=false)
          .catch(err => console.log('ERR', err.message));
      } else {
        ref.remove()
          .then(() => this.visible=false)
          .catch(err => console.log('ERR', err.message));
      }
    }
  },
  mounted() {
    this.selectedScenes = Object.keys((this.item.actived || {}).scene || {}) || [];
    this.selectedContacts = Object.keys((this.item.actived || {}).notify || {}) || [];
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reactor/MacroReflectDialog.vue